/**
 * Self-service user profile updates — 2026-08-17 firm-email-template spec.
 * The caller's own `emailSignoff` (the block filling `{{signoff}}` in the
 * firm email template). Backend routes are on the auth router:
 *   GET   /api/auth/me            -> { success, data: { ..., emailSignoff } }
 *   PATCH /api/auth/me { emailSignoff?, uiPalette? } -> { success, data: { emailSignoff, uiPalette } }
 */
import { apiClient } from './client';

export interface UpdateMeInput {
  emailSignoff?: string | null;
  /** Appearance per user (2026-10-02); null = platform default. */
  uiPalette?: string | null;
}

export type WorkspaceProvider = 'MICROSOFT' | 'GOOGLE';

export interface MeUserResponse {
  id: string;
  email: string;
  displayName: string;
  emailSignoff: string | null;
  /** The palette this user picked; null/absent = parchment. */
  uiPalette?: string | null;
  /**
   * Which workspace the caller's FIRM is on (2026-09-29 provider-aware
   * labelling) — drives every "Outlook" vs "Gmail" word in the UI via
   * `useMailBrand()`. `null` when the firm has no workspace connection yet;
   * absent when talking to an API older than 2026-09-29. Both fall back to
   * Microsoft wording, which is what the UI said unconditionally before.
   */
  workspaceProvider?: WorkspaceProvider | null;
}

export const usersMeApi = {
  get: async (): Promise<MeUserResponse> =>
    (await apiClient.get<{ success: true; data: MeUserResponse }>('/api/auth/me')).data,
  update: async (patch: UpdateMeInput): Promise<{ emailSignoff: string | null; uiPalette?: string | null }> =>
    (
      await apiClient.patch<{ success: true; data: { emailSignoff: string | null; uiPalette?: string | null } }>(
        '/api/auth/me',
        patch,
      )
    ).data,
};
